export default __webpack_public_path__ + "locales/sk/Article.json?hash=aea070771a523790f91621892cce1a26";